import request from '@/utils/request'

export function logout() {
  return request.post('/auth/logout')
}

export function initWeChatScan(inviteCode) {
  const data = inviteCode ? { inviteCode } : {}
  return request.post('/wechat/scan/init', data)
}

export function getWeChatScanStatus(ticket) {
  return request.get('/wechat/scan/status', { params: { ticket } })
}

export function exchangeWeChatScan(data) {
  return request.post('/wechat/scan/exchange', data)
}

export function exchangeWeChatOAuth(code) {
  return request.post('/wechat/oauth/exchange', null, { params: { code } })
}

export function buildWeChatOAuthUrl(redirect, inviteCode) {
  const params = new URLSearchParams()
  if (redirect) {
    params.set('redirect', redirect)
  }
  if (inviteCode) {
    params.set('invite', inviteCode)
  }
  const query = params.toString()
  return '/api/portal/wechat/oauth/authorize' + (query ? '?' + query : '')
}

/** 仅开发环境：本地开发登录（需后端 portal.dev-login.enabled=true） */
export function devLogin(payload = {}) {
  const data = {}
  if (payload.username) {
    data.username = payload.username.trim()
  }
  if (payload.inviteCode) {
    data.inviteCode = payload.inviteCode.trim()
  }
  return request.post('/auth/dev-login', data)
}

export const isDevLoginAvailable = process.env.NODE_ENV === 'development'
